const initState = {
  LatestRestaurantStats: {},
  latestOrderAnalysis: [],
  latestRevenueEarned: {},
  latestSellers: {},
  latestVisits: {},
  latestTopProducts: [],
  latestTopMerchants: [],
  latestPeakHours: {},
  latestPaymentMethod: [],
  latestTotalCustomer: {},
};
const statsReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_RESTAURANT_STATS_SUCCESS":
      return {
        ...state,
        LatestRestaurantStats: action.payload,
      };
    case "FETCH_ORDER_ANALYSIS_SUCCESS":
      return {
        ...state,
        latestOrderAnalysis: action.payload,
      };
    case "FETCH_REVENUE_EARNED_SUCCESS":
      return {
        ...state,
        latestRevenueEarned: action.payload,
      };
    case "FETCH_SELLERS_CHARTS_SUCCESS":
      return {
        ...state,
        latestSellers: action.payload,
      };

    case "FETCH_PRODUCTS_BY_POPULARITY_SUCCESS":
      return {
        ...state,
        latestProducts: action.payload,
      };

    case "FETCH_VISIT_CARDS_SUCCESS":
      return {
        ...state,
        latestVisits: action.payload,
      };
    case "FETCH_TOP_MERCHANTS_SUCCESS":
      return {
        ...state,
        latestTopMerchants: action.payload,
      };

    case "FETCH_PEAK_HOURS_SUCCESS":
      return {
        ...state,
        latestPeakHours: action.payload,
      };

    case "FETCH_PAYMENT_METHODS_SUCCESS":
      return {
        ...state,
        latestPaymentMethod: action.payload,
      };
    case "FETCH_TOTAL_CUSTOMER_SUCCESS":
      return {
        ...state,
        latestTotalCustomer: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default statsReducer;
